/* src/app/modules_v2/investment/investment-company/components/investment-company-form-dialog/investment-company-form-dialog.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.icf-header-text {
  min-width: 0;
  padding-right: 32px;
}
.icf-section + .icf-section {
  margin-top: 6px;
}
.icf-section .cf-dlg-section__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.icf-hint {
  font-size: 12px;
  color: #6b7280;
  margin: -12px 0 12px 4px;
}
.icf-toggle {
  display: block;
  margin: 0 0 14px 2px;
}
.icf-file-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  text-transform: none;
  letter-spacing: 0;
}
.icf-file-input {
  display: none;
}
.icf-btn--danger.cf-btn:hover {
  color: #dc2626 !important;
  border-color: #fecaca !important;
}
.icf-file-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 120px;
  padding: 12px;
  border: 1px dashed #e5e7eb;
  border-radius: 10px;
  font-size: 13px;
  color: #6b7280;
  text-align: center;
}
.icf-file-empty mat-icon {
  font-size: 30px;
  width: 30px;
  height: 30px;
  color: #cbd5e1;
}
.icf-file-preview {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #f8fafc;
}
.icf-file-preview img {
  display: block;
  max-width: 100%;
  max-height: 420px;
  margin: 0 auto;
  object-fit: contain;
}
.icf-file-preview iframe {
  display: block;
  width: 100%;
  height: 460px;
  border: 0;
}
.icf-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 12px;
  padding: 10px 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #4b5563;
}
.icf-alert mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.icf-alert--error {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}
@media (max-width: 600px) {
  .icf-file-preview iframe {
    height: 320px;
  }
}
/*# sourceMappingURL=investment-company-form-dialog.component.css.map */
